// Frontend API client utilities

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL
  || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000');

// Create axios instance
const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiClient;

// API Endpoints
export const API_ENDPOINTS = {
  // Auth
  REGISTER: '/api/auth/register',
  LOGIN: '/api/auth/login',
  ME: '/api/auth/me',
  USERS: '/api/auth/users',
  
  // Platforms
  PLATFORMS: '/api/platforms',
  
  // Properties
  PROPERTIES: '/api/properties',
  PLATFORM_ACCOUNTS: '/api/properties/accounts',
  
  // Bookings
  BOOKINGS: '/api/bookings',

  // Ledger (オーナー精算)
  LEDGER_CONFIG: '/api/ledger/config',
  LEDGER_EXPENSES: '/api/ledger/expenses',
  LEDGER_SUMMARY: '/api/ledger/summary',
  LEDGER_PAYMENTS: '/api/ledger/payments',
  LEDGER_FIXED_COSTS: '/api/ledger/fixed-costs',
  LEDGER_EXPORT: '/api/ledger/export',
  LEDGER_STATEMENT: '/api/ledger/statement',
  LEDGER_EXPORT_YEAR: '/api/ledger/export-year',
  LEDGER_TAX_SUMMARY: '/api/ledger/tax-summary',
  LEDGER_EXPORT_TAX: '/api/ledger/export-tax',
  LEDGER_EXPORT_JOURNAL: '/api/ledger/export-journal',

  // LINE
  LINE_CHECKIN_REQUEST: '/api/line/checkin-request',
  GUEST_TEMPLATES: '/api/line/templates',

  // Emails
  EMAILS: '/api/emails',
  EMAIL_TEMPLATES: '/api/emails/templates/',
  AUTO_RULES: '/api/settings/rules/',
  
  // Settings
  SETTINGS: '/api/settings',

  // サイト投稿 (tnewt.com への公開)
  CMS_STATUS: '/api/cms/status',
  CMS_POSTS: '/api/cms/posts',
  CMS_FACILITIES: '/api/cms/facilities',
  CMS_PROPERTIES: '/api/cms/properties',
  CMS_ROOMS: '/api/cms/rooms',
  CMS_IMAGES: '/api/cms/images',
};

// Helper functions
export const fetchData = async (endpoint) => {
  try {
    const response = await apiClient.get(endpoint);
    return response.data;
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
};

export const postData = async (endpoint, data) => {
  try {
    const response = await apiClient.post(endpoint, data);
    return response.data;
  } catch (error) {
    console.error('Post error:', error);
    throw error;
  }
};

export const updateData = async (endpoint, data) => {
  try {
    const response = await apiClient.put(endpoint, data);
    return response.data;
  } catch (error) {
    console.error('Update error:', error);
    throw error;
  }
};

export const deleteData = async (endpoint) => {
  try {
    const response = await apiClient.delete(endpoint);
    return response.data;
  } catch (error) {
    console.error('Delete error:', error);
    throw error;
  }
};
